import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Axios from "axios";
import { i18n } from "@/plugins/i18n";

Vue.config.productionTip = false;

Axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (401 === error.response.status) {
      store.dispatch("PostSuccessLogout");
    } else {
      return Promise.reject(error);
    }
  }
);

router.beforeEach((to, from, next) => {
  const publicPages = ["/login", "/resetpassword", "/forgotpassword"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = store.getters.User;

  const adminPages = ["/users"];
  const adminRequired = adminPages.includes(to.path);

  if (authRequired && !loggedIn) {
    return next("/login");
  } else if (!authRequired && loggedIn) {
    return next("/");
  } else if (adminRequired && !store.getters.isAdmin) {
    return next("/");
  }

  next();
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
